import React from "react";
import { useSelector } from "react-redux";
import { DollarSign, Eye } from "lucide-react";
import { Badge } from "antd";

const DueSoonCard = () => {
  const actionRequiredData = useSelector((state) => state.dashboard.clientActionRequiredSummary.data);
  const dueSoon = actionRequiredData?.invoiceDueSoonList;
  if (dueSoon.length === 0) return null;  

  return (
    <div className="space-y-2">
      <div className="flex items-center gap-1.5 mb-2">
        <DollarSign className="w-3.5 h-3.5 text-yellow-600 dark:text-yellow-300" />
        <h3 className="text-[12px] title-text">
          Due Soon
        </h3>
        <Badge
          count={dueSoon.length}          
          size="small"
          style={{
            backgroundColor: "rgb(234 179 8)", 
            color: "#ffffff",
            fontSize: "9px",
          }}
        />
      </div>

      {dueSoon.map((item, idx) => (
        <div key={idx} className="card-border-s yellow-white rounded-xl">
          <div className="items-start gap-1.5 pb-2 pt-3 px-3">
            <div className="flex items-start justify-between gap-2">
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-1.5 mb-1 flex-wrap">
                  <h4 className="text-[13px] title-text">{item.title}</h4>
                  <Badge
                    count="due-soon"
                    size="small"
                    style={{
                      backgroundColor: "rgb(234 179 8)",
                      color: "#fff",
                      fontSize: "9px",
                    }}
                  />
                </div>
                <p className="text-[11px] line-clamp-1 muted-text">
                  {item.description}
                </p>
              </div>

              <div className="text-right shrink-0">
                <div className="text-[15px] font-semibold text-yellow-600 dark:text-yellow-400">
                  ${item.amountDue?.toFixed(2)}
                </div>
                <p className="text-[9px] muted-text">Due: {item.dueDate}</p>
              </div>
            </div>
          </div>

          <div className="pb-6 px-3 pb-2 mt-6">
            <div className="flex items-center justify-between gap-2">
              <div className="flex items-center gap-1 flex-wrap">
                <p className="status-indicator normal text-[8px] bg-slate-50">
                  {item.department}
                </p>
                <p className="status-indicator normal text-[8px] bg-slate-50">
                  {item.invoiceNumber}
                </p>
              </div>

              <div className="flex items-center gap-1.5 shrink-0">
                <button className="status-indicator rounded-lg h-6 text-[10px] px-2 bg-white">
                  <Eye className="w-3 h-3" />
                </button>
                <button className="inline-flex items-center justify-center rounded-lg gap-1.5 h-6 text-[10px] px-2 bg-yellow-600 hover:bg-yellow-700 text-white">
                  <DollarSign className="w-3 h-3 mr-1" />
                  Pay
                </button>
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default DueSoonCard;
